import type { IBuildVersion } from '../types/IComponentTypes';

const getVersion = async (): Promise<IBuildVersion> => {
  return fetch('/versioninfo.json').then((response) => response.json());
};

export const version = await getVersion();
